import api from './APIService';

class AccountStatusService {
	getMultiple(data) {
		return api.fetch({ method: 'post', path: '/participant/accountStatus', data });
	}
}

export default new AccountStatusService();
